import PageHero from '@/components/PageHero'
import SEOHead from '@/components/SEOHead'
import { blogPosts } from '@/data/blogPosts'
import { navigateTo } from '@/lib/hashRouter'
import {ArrowRight, BookOpen} from 'lucide-react'

function Blog() {
  return (
    <div>
      <SEOHead
        title="Blog"
        description="In-depth guides on ROAS, ROI, MER, and digital advertising performance benchmarks."
      />
      <PageHero
        eyebrow="Guides & benchmarks"
        title="Blog & Resources"
        description="Practical writing on advertising ROI, ROAS, and profitability metrics for PPC operators."
      />

      <section className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-14">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {blogPosts.map(post => (
            <button
              key={post.slug}
              onClick={() => navigateTo(`/blog/${post.slug}`)}
              className="text-left bg-white rounded-2xl border border-slate-200 p-6 hover:border-emerald-300 hover:shadow-[0_8px_24px_rgba(15,23,42,0.06)] transition-all group flex flex-col"
            >
              <div className="w-10 h-10 rounded-lg bg-emerald-50 border border-emerald-100 flex items-center justify-center mb-4">
                <BookOpen className="w-5 h-5 text-emerald-600" />
              </div>
              <span className="text-[11px] font-semibold text-emerald-700 uppercase tracking-[0.14em]">{post.category}</span>
              <h2 className="mt-2 text-[17px] font-extrabold text-slate-900 leading-snug tracking-tight group-hover:text-emerald-700 transition-colors">
                {post.title}
              </h2>
              <p className="mt-2 text-sm text-slate-500 flex-1 leading-relaxed">{post.excerpt}</p>
              <div className="mt-5 pt-4 border-t border-slate-100 flex items-center justify-between text-sm">
                <span className="text-slate-400">{post.readTime}</span>
                <span className="inline-flex items-center gap-1 text-emerald-700 font-semibold">
                  Read more
                  <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5" />
                </span>
              </div>
            </button>
          ))}
        </div>
      </section>
    </div>
  )
}

export default Blog
